import * as React from "react";
import { useErrorBoundary } from "react-error-boundary";
import { Button } from "@jhool-io/fe-components";
import { useAppDispatch, useAppSelector } from "../../../hooks/useRedux";
import { toggleNavState } from "../../../redux/features/nav/navSlice";
import { cn } from "../../../utils/helpers";
import MenuIcon from "../../Icons/Menu";
import "./ContentFallback.css";

export default function ContentFallback() {
    const { isOpen } = useAppSelector((state) => state.nav);
    const dispatch = useAppDispatch();
    const { resetBoundary } = useErrorBoundary();

    return (
        <div
            id="main"
            className={cn(
                "min-h-screen flex flex-col flex-1 ml-[25.6rem] max-[1000px]:ml-0",
                { "!ml-0": !isOpen }
            )}
        >
            <div className="w-full bg-white shadow-sm flex items-center justify-between h-[7.2rem] px-32">
                {!isOpen && (
                    <Button
                        type="button"
                        size="auto"
                        variant="normal"
                        onClick={() => dispatch(toggleNavState())}
                        className="w-20 h-20 rounded-[2px] border border-[#b8bec5] bg-[rgba(185,186,163,0.25)] flex items-center justify-center"
                    >
                        <MenuIcon className="menu-icon" />
                    </Button>
                )}
            </div>

            <div className="w-full max-w-full flex-1 flex flex-col items-center justify-center text-center px-20">
                <h3 className="text-xxl font-normal mb-10">
                    Something went wrong
                </h3>
                <p className="font-semibold text-sm leading-6 w-[40rem] max-w-full">
                    You just encountered an unexpected error. We have been made
                    aware of it and we will address this issue as quickly as we
                    can. Please contact support to provide more information on
                    the issue. Thank you for your understanding.
                </p>
                <Button
                    type="button"
                    size="small"
                    onClick={resetBoundary}
                    className="px-10 mt-20"
                >
                    Go back
                </Button>
            </div>
        </div>
    );
}
